import { AxiosError } from 'axios';

import {
    GET_CHANNELS,
    GET_CHANNELS_FAILURE,
    GET_CHANNELS_REQUEST,
    GET_CHANNELS_SUCCESS,
    SET_NOW_NEXT_BY_CHANNEL_ID,
} from 'store/programs/constants';
import {
    BTVServicesResponse,
    NowNextResponse,
} from 'store/railsBuilder/reducer.types';
import { AsyncActionMetaOptions } from 'store/types.ts';

export function getChannels(
    meta: AsyncActionMetaOptions<BTVServicesResponse, AxiosError> = {},
) {
    return {
        type: GET_CHANNELS,
        meta,
    };
}

export function getChannelsRequest() {
    return {
        type: GET_CHANNELS_REQUEST,
    };
}

export function getChannelsSuccess(channelsResponse: BTVServicesResponse) {
    return {
        type: GET_CHANNELS_SUCCESS,
        payload: { channelsResponse },
    };
}

export function getChannelsFailure(error: any) {
    return {
        type: GET_CHANNELS_FAILURE,
        payload: { error },
    };
}

export function setNowNextByChannelId(nowNextResponse: NowNextResponse) {
    return { type: SET_NOW_NEXT_BY_CHANNEL_ID, payload: { nowNextResponse } };
}
